import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { lastValueFrom } from 'rxjs';
import {
  CertificationRequestStatus,
  UserRole,
} from '../data/UpuServiceDataCertificationRequestModel';
import { CertificationApi } from '../features/certification-request/certification-api';
import { UserApi } from '../features/user/user-api';
import { ROUTE_DATA } from './route-data';

export const selfAssessmentGuard: CanActivateFn = async (route) => {
  const router = inject(Router);
  const userApi = inject(UserApi);
  const certificationApi = inject(CertificationApi);

  const requestId = Number(route.paramMap.get('requestId'));
  const detailsUrl = router.createUrlTree([
    ROUTE_DATA.requests.path,
    ROUTE_DATA.details.path,
    requestId,
  ]);

  if (userApi.userRole() === UserRole.SecurityFocalPoint) {
    const requestStatus = await lastValueFrom(
      certificationApi.getCertificationRequestStatus(requestId),
    );

    if (requestStatus === CertificationRequestStatus.Draft) {
      return true;
    }
  }

  return detailsUrl;
};
